import { render, staticRenderFns } from "./GenericPage.vue?vue&type=template&id=7e2783d8"
import script from "./GenericPage.vue?vue&type=script&lang=js"
export * from "./GenericPage.vue?vue&type=script&lang=js"
import style0 from "./GenericPage.vue?vue&type=style&index=0&id=7e2783d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports